import type { FaireProductEntity } from "../../entity_types/product";

export const p_rvnkhj7u6a: FaireProductEntity = {
  token: "p_rvnkhj7u6a",
  type: "product",
  name: "Stevie",
  brandToken: "b_gtd953ydde",
  brandName: "Meadow & Mae",
  imageUrl:
    "https://cdn.faire.com/fastly/df96582784c46eec429a726e6fc1b78743ca1999a84b45e7716192b8d114973a.jpeg",
  galleryImageUrls: [],
  priceDollars: 16,
  description:
    "A combination of classic black and white checkerboard and rich purple and green makes these dangles the perfect bold addition to any outfit!\n",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:41.470Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
